module.exports = __webpack_public_path__ + "static/jeff-af5e8a58002c5a21859ab0939fcc4f52.png";